import actions from "./global-actions";
import state from "./global-store";
import mutations from "./global-mutations";
import getters from "./global-getters";

const globalStore = {
  state,
  mutations,
  actions,
  getters,
};

export default globalStore;
